import { createRegistry } from '../registry.js';
export const viewTypeRegistry = createRegistry('view-type-registry', (definition) => definition.id);
export function defineViewType(definition) {
    return definition;
}
export function registerViewType(definition) {
    viewTypeRegistry.register(definition);
    return definition;
}
/**
 * The shared body of every kind's `normaliseSettings`: merge a partial patch over the kind's
 * defaults, then parse. `zod`'s issues become the message, so a caller sees which field it got
 * wrong rather than "invalid settings".
 */
export function normaliseOverDefaults(kind, schema, defaults, input) {
    const patch = input === null || input === undefined ? {} : input;
    if (typeof patch !== 'object' || Array.isArray(patch)) {
        throw new TypeError(`${kind} view settings must be an object`);
    }
    const result = schema.safeParse({ ...defaults, ...patch });
    if (!result.success) {
        const detail = result.error.issues
            .map((issue) => `${issue.path.join('.') || '(root)'}: ${issue.message}`)
            .join('; ');
        throw new TypeError(`${kind} view settings are invalid — ${detail}`);
    }
    return result.data;
}
//# sourceMappingURL=types.js.map